import { render, staticRenderFns } from "./historialPedidoModal.vue?vue&type=template&id=028169f6&scoped=true&"
import script from "./historialPedidoModal.vue?vue&type=script&lang=js&"
export * from "./historialPedidoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028169f6",
  null
  
)

export default component.exports